module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"done":"Jobs added","submit":"Add jobs","title":"Add article batch"}}')
  delete Component.options._Ctor
}
